import { motion } from 'framer-motion';


export const WatercolorBlob = ({ styles, children }) => {

  const blobStyles = {
    container: {
      position: 'fixed', // Changed from 'relative' to 'fixed'
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      overflow: 'hidden',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      zIndex: 0, // Changed from 1 to 0 so content sits on top
      pointerEvents: 'none' // Allow clicks to pass through to content
    },
    
    svgFilters: {
      position: 'absolute',
      width: 0,
      height: 0
    },

    gooeyContainer: {
      position: 'absolute',
      width: '100%',
      height: '100%',
      filter: 'url(#gooeyEffect)'
    },

    blob1: {
      position: 'absolute',
      width: '750px',
      height: '750px',
      left: '15%',
      top: '25%',
      background: 'radial-gradient(ellipse at center, rgba(214, 229, 156, 0.8) 0%, rgba(193, 223, 224, 0.6) 30%, rgba(191, 201, 179, 0.4) 60%, rgba(242, 236, 204, 0.2) 100%)',
      borderRadius: '50%',
      filter: 'blur(25px) url(#turbulenceFilter)',
      animation: 'blob1Move 20s ease-in-out infinite'
    },

    blob2: {
      position: 'absolute',
      width: '680px',
      height: '680px',
      left: '55%',
      top: '15%',
      background: 'radial-gradient(ellipse at center, rgba(151, 182, 171, 0.7) 0%, rgba(195, 189, 204, 0.5) 30%, rgba(207, 217, 219, 0.4) 60%, rgba(179, 187, 191, 0.2) 100%)',
      borderRadius: '50%',
      filter: 'blur(20px) url(#turbulenceFilter)',
      animation: 'blob2Move 25s ease-in-out infinite'
    },

    blob3: {
      position: 'absolute',
      width: '320px',
      height: '320px',
      left: '75%',
      top: '25%',
      background: 'radial-gradient(ellipse at center, rgba(129, 172, 162, 0.6) 0%, rgba(221, 255, 196, 0.5) 30%, rgba(206, 232, 231, 0.3) 60%, rgba(176, 200, 185, 0.1) 100%)',
      borderRadius: '50%',
      filter: 'blur(18px) url(#turbulenceFilter)',
      animation: 'blob3Move 30s ease-in-out infinite'
    },

    blob4: {
      position: 'absolute',
      width: '590px',
      height: '590px',
      left: '2%',
      top: '45%',
      background: 'radial-gradient(ellipse at center, rgba(220, 246, 236, 0.5) 0%, rgba(220, 236, 219, 0.4) 30%, rgba(218, 214, 207, 0.3) 60%, rgba(158, 152, 147, 0.15) 100%)',
      borderRadius: '50%',
      filter: 'blur(22px) url(#turbulenceFilter)',
      animation: 'blob4Move 22s ease-in-out infinite'
    },

    blob5: {
      position: 'absolute',
      width: '800px',
      height: '800px',
      left: '15%',
      top: '20%',
      background: 'radial-gradient(ellipse at center, rgba(216, 249, 224, 0.6) 0%, rgba(195, 209, 188, 0.4) 30%, rgba(215, 233, 232, 0.3) 60%, rgba(255, 239, 210, 0.1) 100%)',
      borderRadius: '50%',
      filter: 'blur(28px) url(#turbulenceFilter)',
      animation: 'blob5Move 28s ease-in-out infinite'
    },

    blob6: {
      position: 'absolute',
      width: '460px',
      height: '460px',
      left: '70%',
      top: '10%',
      background: 'radial-gradient(ellipse at center, rgba(131, 190, 164, 0.4) 0%, rgba(152, 164, 165, 0.3) 30%, rgba(221, 244, 255, 0.2) 60%, rgba(186, 253, 219, 0.1) 100%)',
      borderRadius: '50%',
      filter: 'blur(15px) url(#turbulenceFilter)',
      animation: 'blob6Move 35s ease-in-out infinite'
    },

    mouseFollower: {
      position: 'absolute',
      width: '580px',
      height: '580px',
      background: 'radial-gradient(ellipse at center, #10b98166 0%, rgba(52, 211, 153, 0.3) 40%, rgba(110, 231, 183, 0.1) 80%, transparent 100%)',
      borderRadius: '50%',
      filter: 'blur(25px) url(#turbulenceFilter)',
      pointerEvents: 'none',
      transition: 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    },

    particle: {
      position: 'absolute',
      width: '100',
      height: '100',
      background: 'radial-gradient(ellipse at center, rgba(199, 209, 201, 0.7) 0%, rgba(219, 233, 230, 0.4) 50%, transparent 100%)',
      borderRadius: '50%',
      filter: 'blur(8px) url(#turbulenceFilter)',
      animation: 'particleFloat 12s ease-in-out infinite'
    },

    textureOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      opacity: 0.15,
      mixBlendMode: 'multiply',
      pointerEvents: 'none',
      background: `
        radial-gradient(circle at 25% 35%, rgba(255, 165, 0, 0.08) 0%, transparent 50%),
        radial-gradient(circle at 65% 25%, rgba(255, 20, 147, 0.06) 0%, transparent 50%),
        radial-gradient(circle at 85% 65%, rgba(138, 43, 226, 0.05) 0%, transparent 50%),
        radial-gradient(circle at 15% 75%, rgba(30, 144, 255, 0.04) 0%, transparent 50%),
        radial-gradient(circle at 45% 85%, rgba(255, 215, 0, 0.06) 0%, transparent 50%)
      `,
      filter: 'url(#noiseTexture)'
    },
    

    content: {
      position: 'relative',
      zIndex: 10,
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center'
    },

};
  return (
    <div style={blobStyles.container}>
      {/* SVG Filters */}
      <svg style={blobStyles.svgFilters}>
        <defs>
          {/* Turbulence/Noise Filter */}
          <filter id="turbulenceFilter" x="0%" y="0%" width="100%" height="100%">
            <feTurbulence 
              baseFrequency="0.9" 
              numOctaves="2" 
              result="noise"
              seed="2"
              type="fractalNoise"
            />
            <feDisplacementMap 
              in="SourceGraphic" 
              in2="noise" 
              scale="12"
              result="displacement"
            />
            <feGaussianBlur 
              in="displacement" 
              stdDeviation="3" 
              result="blur"
            />
          </filter>
          
          {/* Gooey Effect */}
          <filter id="gooeyEffect" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur in="SourceGraphic" stdDeviation="12" result="blur" />
            <feColorMatrix 
              in="blur" 
              mode="matrix" 
              values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -8" 
              result="gooey" 
            />
          </filter>

          {/* Fine Noise Texture */}
          <filter id="noiseTexture" x="0%" y="0%" width="100%" height="100%">
            <feTurbulence 
              baseFrequency="0.85" 
              numOctaves="4" 
              result="fineNoise"
              seed="5"
              type="turbulence"
            />
            <feComponentTransfer in="fineNoise" result="contrast">
              <feFuncA type="discrete" tableValues="0 0.3 0.6 0.9"/>
            </feComponentTransfer>
          </filter>
        </defs>
      </svg>

      {/* Gooey Container */}
      <div style={blobStyles.gooeyContainer}>
        {/* Main Gradient Blobs */}
        <motion.div
          style={blobStyles.blob1}
          animate={{
            borderRadius: [
              "60% 40% 30% 70% / 60% 30% 70% 40%",
              "30% 60% 70% 40% / 50% 60% 30% 60%",
              "50% 60% 30% 60% / 60% 40% 60% 30%",
              "60% 40% 60% 30% / 30% 50% 40% 70%",
              "60% 40% 30% 70% / 60% 30% 70% 40%"
            ]
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />

        <motion.div
          style={blobStyles.blob2}
          animate={{
            borderRadius: [
              "40% 60% 60% 40% / 70% 40% 30% 60%",
              "60% 40% 30% 70% / 40% 70% 60% 30%",
              "30% 70% 40% 60% / 60% 30% 40% 70%",
              "70% 30% 60% 40% / 30% 60% 70% 40%",
              "40% 60% 60% 40% / 70% 40% 30% 60%"
            ]
          }}
          transition={{
            duration: 25,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />

        <motion.div style={blobStyles.blob3} />
        <motion.div style={blobStyles.blob4} />
        <motion.div style={blobStyles.blob5} />
        <motion.div style={blobStyles.blob6} />

        {/* Floating Particles */}
        {Array.from({ length: 15 }).map((_, index) => (
          <motion.div
            key={index}
            style={{
              ...blobStyles.particle,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`
            }}
            animate={{
              x: [0, 100 * Math.random() - 50, -75 * Math.random(), 90 * Math.random() - 45, 0],
              y: [0, -90 * Math.random(), 80 * Math.random() - 40, 60 * Math.random() - 30, 0],
              scale: [0.5, 1.2, 0.8, 1.1, 0.5],
              opacity: [0.3, 0.8, 0.6, 0.9, 0.3]
            }}
            transition={{
              duration: 12 + Math.random() * 8,
              delay: Math.random() * 8,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          />
        ))}
      </div>
      

      {/* Texture Overlay */}
      <div style={blobStyles.textureOverlay} />

      <style jsx>{`
        @keyframes blob1Move {
          0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }
          25% { transform: translate(120px, -100px) scale(1.1) rotate(90deg); }
          50% { transform: translate(-80px, 140px) scale(0.9) rotate(180deg); }
          75% { transform: translate(160px, -80px) scale(1.15) rotate(270deg); }
        }

        @keyframes blob2Move {
          0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }
          25% { transform: translate(-140px, 120px) scale(1.2) rotate(120deg); }
          50% { transform: translate(100px, -110px) scale(0.85) rotate(240deg); }
          75% { transform: translate(-80px, 160px) scale(1.05) rotate(300deg); }
        }

        @keyframes blob3Move {
          0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }
          33% { transform: translate(-120px, -140px) scale(1.25) rotate(144deg); }
          66% { transform: translate(140px, 100px) scale(0.8) rotate(288deg); }
        }

        @keyframes blob4Move {
          0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }
          30% { transform: translate(160px, -120px) scale(1.1) rotate(108deg); }
          60% { transform: translate(-100px, 140px) scale(0.9) rotate(216deg); }
        }

        @keyframes blob5Move {
          0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }
          25% { transform: translate(-120px, -100px) scale(1.15) rotate(72deg); }
          50% { transform: translate(140px, 120px) scale(0.85) rotate(144deg); }
          75% { transform: translate(-160px, -80px) scale(1.08) rotate(288deg); }
        }

        @keyframes blob6Move {
          0%, 100% { transform: translate(0, 0) scale(1) rotate(0deg); }
          20% { transform: translate(100px, 80px) scale(1.3) rotate(60deg); }
          40% { transform: translate(-80px, -60px) scale(0.7) rotate(120deg); }
          60% { transform: translate(120px, -100px) scale(1.1) rotate(240deg); }
          80% { transform: translate(-60px, 120px) scale(0.9) rotate(300deg); }
        }

        @keyframes particleFloat {
          0%, 100% { 
            transform: translate(0, 0) scale(0.5); 
            opacity: 0.3; 
          }
          25% { 
            transform: translate(200px, -180px) scale(1.2); 
            opacity: 0.8; 
          }
          50% { 
            transform: translate(-150px, 160px) scale(0.8); 
            opacity: 0.6; 
          }
          75% { 
            transform: translate(180px, 120px) scale(1.1); 
            opacity: 0.9; 
          }
        }
      `}</style>
    </div>
  );
};

export default WatercolorBlob;